import React, { ReactNode } from "react";
import { Link } from "react-router-dom";

interface StatsCardProps {
  icon: ReactNode;
  title: string;
  count: number | string;
  linkTo: string;
  onClick?: (e: React.MouseEvent) => void;
}

const StatsCard: React.FC<StatsCardProps> = ({
  icon,
  title,
  count,
  linkTo,
  onClick,
}) => {
  return (
    <div className="cursor-pointer sm:w-auto group">
      <Link to={linkTo} onClick={onClick}>
        {icon}
        <div className="mt-4 text-lg text-gray-700 group-hover:text-blue-700">
          <p>{title}</p>
          <p className="group-hover:font-bold">
            {typeof count === "number" ? count.toLocaleString() : count}
          </p>
        </div>
      </Link>
    </div>
  );
};

export default StatsCard;
